import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';

export type OnboardingSegment = 'retail' | 'b2b-importador' | 'tecnologia' | 'servicios';

interface OnboardingState {
  completed: boolean;
  segment: OnboardingSegment | null;
  step: number;
  isFirstTime: boolean;

  setSegment: (segment: OnboardingSegment) => void;
  setStep: (step: number) => void;
  nextStep: () => void;
  prevStep: () => void;
  complete: () => void;
  skip: () => void;
  reset: () => void;
  clearFirstTime: () => void;
}

export const useOnboardingStore = create<OnboardingState>()(
  devtools(
    persist(
      (set) => ({
        completed: false,
        segment: null,
        step: 0,
        isFirstTime: false,

        setSegment: (segment) => set({ segment }),
        setStep: (step) => set({ step }),
        nextStep: () => set((state) => ({ step: state.step + 1 })),
        prevStep: () => set((state) => ({ step: Math.max(0, state.step - 1) })),
        complete: () => set({ completed: true, step: 0 }),
        skip: () => set({ completed: true, step: 0 }),
        reset: () => set({ completed: false, segment: null, step: 0, isFirstTime: false }),
        clearFirstTime: () => set({ isFirstTime: false }),
      }),
      {
        name: 'onboarding-storage',
        partialize: (state) => ({
          completed: state.completed,
          segment: state.segment,
          step: state.step,
          isFirstTime: state.isFirstTime,
        }),
      }
    ),
    { name: 'OnboardingStore' }
  )
);
